import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaYoutube, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import MainLayout from '../../components/mainLayOut/MainLayout';

const ContactUs = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}! We'll contact you soon.`);
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "What are your operating hours?",
      answer: "Our centers are open Monday to Saturday from 9:00 AM to 7:00 PM."
    },
    {
      question: "Do you offer trial classes?",
      answer: "Yes! We offer one free trial class so you can experience our teaching methodology."
    },
    {
      question: "What's the ideal age to start abacus training?",
      answer: "We recommend starting between ages 5-12, but we have programs for all age groups."
    },
    {
      question: "How long does it take to see results?",
      answer: "Most students show noticeable improvement in mental calculation within 3-6 months."
    }
  ];

  return (
    <MainLayout>
      {/* Hero Section with Gradient Background */}
      <div className="relative bg-gradient-to-r from-blue-600 to-purple-600 py-12 md:py-20 text-white">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">Let's Connect</h1>
          <p className="text-base md:text-xl max-w-2xl mx-auto">
            Have questions about our programs? Want to schedule a free demo class? Reach out to us!
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8 md:py-16">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-12">
          {/* Contact Form - Improved Layout */}
          <div className="bg-white rounded-xl shadow-lg p-4 md:p-8 order-2 lg:order-1">
            <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-6">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-3 md:space-y-6">
              <div className="grid md:grid-cols-2 gap-3 md:gap-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base font-medium">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition text-sm md:text-base"
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base font-medium">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition text-sm md:text-base"
                    placeholder="your@email.com"
                    required
                  />
                </div>
              </div>

              <div>
                <label htmlFor="phone" className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base font-medium">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition text-sm md:text-base"
                  placeholder="+91 9876543210"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base font-medium">Your Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition text-sm md:text-base"
                  placeholder="How can we help you?"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium md:font-bold py-2 md:py-3 px-4 md:px-6 rounded-lg shadow hover:shadow-lg transition-all duration-300 text-sm md:text-base"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information - Improved Visual Hierarchy */}
          <div className="space-y-4 md:space-y-8 order-1 lg:order-2">
            {/* Contact Cards */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 md:p-6 shadow-lg">
              <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-3 md:mb-4">Contact Information</h3>
              
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start bg-white p-3 md:p-4 rounded-lg shadow-sm">
                  <div className="bg-blue-100 p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
                    <FaPhone className="text-blue-600 text-base md:text-lg animate-bounce" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-800 text-sm md:text-base">Call Us</h4>
                    <p className="text-gray-600 text-xs md:text-sm">+91 9876543210</p>
                    <p className="text-gray-600 text-xs md:text-sm">+91 1234567890</p>
                  </div>
                </div>

                <div className="flex items-start bg-white p-3 md:p-4 rounded-lg shadow-sm">
                  <div className="bg-blue-100 p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
                    <FaEnvelope className="text-blue-600 text-base md:text-lg animate-bounce" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-800 text-sm md:text-base">Email Us</h4>
                    <p className="text-gray-600 text-xs md:text-sm">info@ascentabacus.com</p>
                    <p className="text-gray-600 text-xs md:text-sm">support@ascentabacus.com</p>
                  </div>
                </div>

                <div className="flex items-start bg-white p-3 md:p-4 rounded-lg shadow-sm">
                  <div className="bg-blue-100 p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
                    <FaMapMarkerAlt className="text-blue-600 text-base md:text-lg animate-bounce" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-800 text-sm md:text-base">Visit Us</h4>
                    <p className="text-gray-600 text-xs md:text-sm">123 Education Street</p>
                    <p className="text-gray-600 text-xs md:text-sm">Learning City, 560001</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
              <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-3 md:mb-4">Connect With Us</h3>
              <p className="text-gray-600 text-sm md:text-base mb-4 md:mb-6">Follow us for updates, tips, and success stories!</p>
              
              <div className="grid grid-cols-3 gap-2 md:gap-3">
                <a 
                  href="https://www.facebook.com/ascentabacusbraingym" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center bg-blue-600 hover:bg-blue-700 text-white p-2 md:p-3 rounded-lg transition-all shadow hover:shadow-md"
                >
                  <FaFacebookF className="text-lg md:text-xl mb-1" />
                  <span className="text-xs">Facebook</span>
                </a>
                
                <a 
                  href="https://www.instagram.com/ascent_abacus_brain_gym/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white p-2 md:p-3 rounded-lg transition-all shadow hover:shadow-md"
                >
                  <FaInstagram className="text-lg md:text-xl mb-1" />
                  <span className="text-xs">Instagram</span>
                </a>
                
                <a 
                  href="https://www.youtube.com/@ASCENTABACUSANDBRAINGYM" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center bg-red-600 hover:bg-red-700 text-white p-2 md:p-3 rounded-lg transition-all shadow hover:shadow-md"
                >
                  <FaYoutube className="text-lg md:text-xl mb-1" />
                  <span className="text-xs">YouTube</span>
                </a>
              </div>
            </div>

            {/* Map Embed */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.123456789012!2d77.12345678901234!3d12.123456789012345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDA3JzI0LjQiTiA3N8KwMDcnMjQuNCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                className="w-full h-40 sm:h-48 md:h-64"
                allowFullScreen=""
                loading="lazy"
                title="Ascent Abacus Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* FAQ Section with Smooth Accordion */}
        <div className="mt-12 md:mt-20">
          <h2 className="text-xl md:text-3xl font-bold text-center text-gray-800 mb-6 md:mb-8">Frequently Asked Questions</h2>
          
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-100 last:border-0">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-4 py-3 md:px-6 md:py-4 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors"
                >
                  <h3 className="text-base md:text-lg font-semibold text-gray-800">{faq.question}</h3>
                  {activeFaq === index ? (
                    <FaChevronUp className="text-blue-600 text-sm md:text-base" />
                  ) : (
                    <FaChevronDown className="text-blue-600 text-sm md:text-base" />
                  )}
                </button>
                <div
                  className={`px-4 md:px-6 overflow-hidden transition-all duration-300 ease-in-out ${
                    activeFaq === index ? 'max-h-96 pb-3 md:pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-gray-600 text-sm md:text-base">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactUs;